import { AbstractControl, ValidationErrors } from "@angular/forms";
import { IGenericDataKeyValue } from "@shared/interfaces/generic-data-key-value.interface";

export class FormUtils {

    static emailRegex = /^.+@.+\..{2,4}$/;

    static readonly emptyGenericDataKeyValue: IGenericDataKeyValue = { id: null, description: '---' };

    static compareDates(a: Date, b: Date) : number {
      if(a == b) {
        return 0;
      } else if(a < b) {
        return -1;
      } else {
        return 1;
      }
    }

    /**
     * Disabilita o abilita un controllo di una reactive form
     * @param control il controllo a cui cambiare lo stato
     * @param enabled se deve essere abilitato oppure no
     */
    static toggleEnableAbstractControl(control: AbstractControl, enabled: boolean, emitEvent: boolean = true) {
      if (control) {
        if(enabled && !control.enabled) control.enable({emitEvent});
        else if (!enabled && control.enabled) control.disable({emitEvent});
      }
    }

}